module.exports = __webpack_public_path__ + "static/media/open-eye.4c4b8f68.svg";